<template>
  <div class="content-area">
    <!-- <Navbar :indexMode="true"/> -->
    <h1 class="form-title">To check the status of your application, enter your email address and password</h1>
    <el-form
      label-position="top"
      :model="formData"
      :rules="rules"
      ref="formData"
      label-width="100px"
    >
      <el-form-item
        label="Email Address"
        prop="userName"
      >
        <el-input v-model="formData.userName" maxlength="32" @change="(val)=>inptChange(val,'userName')" placeholder="MID or Email Address"></el-input>
      </el-form-item>

      <el-form-item
        label="Password"
        prop="password"
      >
        <el-input v-model="formData.password" @change="(val)=>inptChange(val,'password')" :type="inputType" placeholder="Password" autocomplete="new-password">
          <template slot="suffix">
            <img v-if="isShow" @click="changeShow" class="right_icon" src="@/assets/pc/mask-outline.svg" />
            <img v-if="!isShow" @click="changeShow" class="right_icon" src="@/assets/pc/Icon - Unmask@3x.png" />
          </template>
        </el-input>
      </el-form-item>
      <p class="forget-text" @click="forgetPwd">Need help?</p>
      <BottomButton :showDefaultBtn="false" mode="check" @click="onSubmit" className="w230"/>
    </el-form>

    <div class="continue-box" v-if="isShowContinue">
      <div class="continue-warp">
        <div class="content-warp">
          <p class="content-title">Welcome back</p>
          <p class="content-title">{{fullName}}</p>
          <p class="content-product">You are applying for {{productTypeText}}</p>
        </div>

        <el-button type="primary" @click="toContinue">Continue</el-button>
      </div>
    </div>
    <Dialog
        :title="tipsTitle"
        :visible.sync="dialogVisible"
        width="480px"
        top="31vh"
        :show-close="false"
        center
    >
      <span>{{tipsContent}}</span>
      <template v-slot:footer>
          <el-button type="primary" @click="dialogVisible=false">OK</el-button>
      </template>
    </Dialog>
  </div>
</template>

<script>
  // import AppForm from '../components/AppForm.vue';
  import API from "@/api"
  import MD5 from '@/plugins/crypto-md5.js'
  import {processWhiteList, ProcessStatus} from "@/common-data/common.js"
  import {getPageNo} from "@/bdo.process.map.js"
  import {Dialog} from 'element-ui'

  export default {
  name: 'CheckMidProcess',
  pRouter: 'App',
  rIndex: 2,
  components: {
    // AppForm,
    Dialog,
  },
  data() {
    return {
      formData: {
        userName: "",
        password: "",
      },
      rules: {
        userName: [
          { required: true, message: 'Please enter the correct information', trigger: 'change' },
        ],
        password: [
          { required: true, message: 'Please enter the correct password', trigger: 'change' }
        ],
      },
      isShowContinue: false,
      fullName: '',
      productTypeText: '',
      processNo: '',
      pageNo: '',
      merchantId: '',
      inputType: 'password',
      isShow: true,
      dialogVisible: false, // 错误弹窗
      tipsTitle: 'Resend OTP limit reached',
      tipsContent: 'Try again after 30 minutes.',
    }
  },
  methods: {
      changeShow() {
        this.isShow = !this.isShow
        if (this.isShow) {
          this.inputType = 'password'
        } else {
          this.inputType = 'text'
        }
      },
      inptChange(val, key){
        this.$set(this.formData, key, val);
      },
      onSubmit() {
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            const { userName, password } = this.formData
            API.login({
              userName,
              password: MD5(password)
            }).then(res => {
              if (res.success) {
                const { token, processNo = '', applyStatus = '', lastPageNo= '', dualVerification, suffixPhone } = res.obj
                this.setCookieItem('token', token)
                this.setCookieItem('userName', userName)
                this.setCookieItem('suffixPhone', suffixPhone)
                // 是否双重验证：1是；2否
                if (dualVerification === 1) {
                  this.toRoute({name: 'LoginOtp'})
                  return
                }
                if (!processNo) {
                  this.toRoute({name: 'WhetherBDOMerchant'})
                  return
                }
                if (applyStatus != '0' && ![5,6].includes(Number(applyStatus))) {
                  this.$router.push({name: 'CheckStatus', query: { status: String(applyStatus) }})
                } else if ([5,6].includes(Number(applyStatus))) {
                  const name = ProcessStatus[String(processNo)].last
                  this.$router.push({name})
                } else {
                  let name = ''
                  if (lastPageNo) {
                    name = getPageNo(String(processNo), String(lastPageNo))
                  } else {
                    name = ProcessStatus[processNo].first
                  }
                  this.$router.push({name: 'CheckStatus', query: { status: String(applyStatus), name, processNo }})
                }
              }else{
                switch (res.errorCode) {
                  case 'ekyc2.otp.account.disable.minute':
                    this.dialogVisible = true;
                    this.tipsTitle = 'The account is locked.'
                    this.tipsContent = `Try again after ${res.msg} minute${res.msg > 1 ? 's':''}.`
                    break;
                  case 'ekyc2.otp.account.disable.second':
                    this.dialogVisible = true;
                    this.tipsTitle = 'The account is locked.'
                    this.tipsContent = `Try again after less than 1 minute.`
                    break;
                
                  default:
                    break;
                }
              }
            })
          } else {
            return false;
          }
        })
      },
      forgetPwd(){
        this.toRoute({name: 'NeedHelp'})
      },
      toContinue(){
        let bdoStep = this.checkProcess(this.processNo, this.pageNo)
        this.setMerchantId(this.merchantId)
        this.updateStepData({flowStep: bdoStep.bdoStep},"flowStep")

        //密码不能重复显示. 所以需要跳过密码页面
        if(processWhiteList[bdoStep.bdoStep]) {
          bdoStep = {bdoStep: processWhiteList[bdoStep.bdoStep]}
        }

        this.toNext(bdoStep)
      }
  }
}
</script>

<style lang="scss" scoped>
  .forget-text{
      font-size: 16px;
      color: #0072D8;
      letter-spacing: 0.14px;
      font-weight: bold;
      cursor: pointer;
  }
  .right_icon {
    width: 24px;
    height: 24px;
    vertical-align: middle;
    margin-top: 7px;
    cursor: pointer;
  }

  .continue-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.30);
    z-index: 1000;
    .continue-warp {
      position: absolute;
      width: 673px;
      // height: 406px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      /*padding: 34px 0px 0px;*/
      background: #FFFFFF;
      border-radius: 14px;
      padding: 72px 0 62px;
      text-align: center;

      .content-title {
        line-height: 18px;
        font-size: 24px;
        color: #2C405A;
        letter-spacing: 0;
        margin-bottom: 30px;
      }

      .content-product{
        font-size: 16px;
        color: #2C405A;
        letter-spacing: 0;
        margin-bottom: 30px;
      }
    }
  }
  ::v-deep .el-dialog{
      border-radius: 16px;
       .el-dialog__header{
            padding-top: 48px;
            padding-bottom: 4px;
            .el-dialog__title{
                text-align: center;
                font: normal normal bold 30px/36px Nunito;
                letter-spacing: 0px;
                color: #2E2E2E;
            }
        }
        .el-dialog__body{
            text-align: center;
            font: normal normal normal 20px/28px Nunito;
            letter-spacing: 0px;
            color: #2E2E2E;
            padding-top: 16px;
            padding-bottom: 32px;
        }
        .el-dialog__footer{
            padding-top: 0;
            padding-bottom: 48px;
            .el-button{
                width: 320px;
                height: 48px;
                border-radius: 8px;
                text-align: center;
                font: normal normal bold 16px/24px Nunito;
                letter-spacing: 0px;
                color: #FFFFFF;
            }
        }
  }
</style>
